import React, { useState, useEffect, useCallback } from "react";
import cx from "classnames";
import Photo from "@components/photo";
import Image from "next/image";
import Icon from "@components/icon";
import useEmblaCarousel from "embla-carousel-react";
const PostListing = ({ post }) => {
  return (
    <div
      className={cx(
        "embla__slide",
        "relative",
        "mb-4",
        "md:mb-0",
        "md:mr-[20px]",
        "w-full",
        "flex-[0_0_100%]",
        "md:flex-[0_0_calc(33.33333333%-12.5px)]"
      )}
    >
      <a
        className={cx("block", "w-full", "h-full")}
        href={post.link}
        target="_blank"
        rel="noreferrer"
      >
        <div
          className={cx(
            "card",
            "bg-white",
            "rounded-[3px]",
            "overflow-hidden",
            "h-full",
            "flex",
            "flex-col"
          )}
        >
          <div
            className={cx(
              "photo",
              "aspect-video",
              "relative",
              "border-b",
              "border-b-yellow",
              "border-b-[5px]"
            )}
          >
            {post?.media?.$?.url && (
              <Image
                src={post.media.$.url}
                alt={post.title}
                layout="fill"
                objectFit="cover"
              />
            )}
          </div>
          <div
            className={cx(
              "title",
              "text-large",
              "font-sansRegular",
              "mb-10",
              "p-2"
            )}
          >
            {post.title}
          </div>
          <div
            className={cx(
              "text-xs-mobile",
              "md:text-xs",
              "font-sansRegular",
              "uppercase",
              "p-2",
              "mt-auto"
            )}
          >
            Read More{" "}
            <div className={cx("long-arrow")}>
              <Icon name="LongArrow" color="#000000" viewBox="0 0 47 13" />
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

const ArticleListing = ({ data = {} }) => {
  const { sectionTitle, dwellRssUrl, backgroundColor, rssPosts } = data;
  const [posts, setPosts] = useState(rssPosts);
  const [viewportRef, embla] = useEmblaCarousel({
    align: "start",
    loop: true,
  });
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);

  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);
  const onSelect = useCallback(() => {
    if (!embla) return;
    setPrevBtnEnabled(embla.canScrollPrev());
    setNextBtnEnabled(embla.canScrollNext());
  }, [embla]);

  useEffect(() => {
    if (!embla) return;
    embla.on("select", onSelect);
    onSelect();
  }, [embla, onSelect]);

  return (
    <section
      className={cx(
        "article-listing",
        "px-gutter",

        `bg-${backgroundColor?.value}`,
        "relative",
        "z-0"
      )}
      data-theme={backgroundColor?.title.toLowerCase()}
    >
      <div
        className={cx(
          "grid",
          "grid-cols-4",
          "md:grid-cols-20",
          "site-container"
        )}
      >
        <div className="col-span-4 block w-full md:col-span-18 md:col-start-2">
          {sectionTitle && (
            <div className={cx("text-lg-2-mobile", "md:text-lg-2", "mb-8")}>
              {sectionTitle}
            </div>
          )}
        </div>
      </div>
      <div
        className={cx(
          "grid",
          "grid-cols-4",
          "md:grid-cols-20",
          "site-container"
        )}
      >
        <div className={cx("col-span-4", "block", "md:hidden")}>
          {posts.slice(0, 3).map((post, idx) => (
            <PostListing key={idx} post={post} />
          ))}
        </div>
        <div
          className={cx(
            "col-span-1",
            "col-start-1",
            "hidden",
            "md:flex",
            "place-content-center"
          )}
        >
          {posts && (
            <button className={cx("w-[40px]")} onClick={() => scrollPrev()}>
              <Icon name="CarouselLeft" viewBox="0 0 64 64" color="#292929" />
            </button>
          )}
        </div>
        <div className="col-span-18 col-start-2">
          {posts && (
            <div
              className={cx(
                "posts-carousel",
                "hidden",
                "md:flex",
                "embla",
                "w-full",
                "overflow-hidden"
              )}
              ref={viewportRef}
            >
              <div className={cx("flex", "w-full", "embla__container")}>
                {posts.map((post, idx) => (
                  <PostListing key={idx} post={post} />
                ))}
              </div>
            </div>
          )}
        </div>
        <div
          className={cx(
            "col-span-1",
            "col-start-20",
            "hidden",
            "md:flex",
            "place-content-center"
          )}
        >
          {posts && (
            <button className={cx("w-[40px]")} onClick={() => scrollNext()}>
              <Icon name="CarouselRight" viewBox="0 0 64 64" color="#292929" />
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default ArticleListing;
